

/* =========================
MAIN SLIDER (Swiper is loaded with "defer" in theme.liquid, so wait for DOMContentLoaded)
========================= */

document.addEventListener("DOMContentLoaded", function(){

  if(typeof Swiper === "undefined") return;

  const thumbEl = document.querySelector(".wsThumbSlider");
  const mainEl = document.querySelector(".wsMainSlider");
  if(!mainEl) return;

  let thumbs = null;

  const galleryEl = mainEl.closest(".ws-gallery-wrapper");
  const thumbsPerView = parseInt(galleryEl && galleryEl.dataset.thumbs) || 7;
  const showMoreBadge = galleryEl && galleryEl.dataset.moreBadge === "true";

  if(thumbEl){
    thumbs = new Swiper(thumbEl, {
      spaceBetween:10,
      slidesPerView:thumbsPerView,
      freeMode:true,
      watchSlidesProgress:true,
    });

    /* "+N More" on the last visible thumbnail when there are more photos than fit */
    const thumbSlides = thumbEl.querySelectorAll(".swiper-slide");
    if(showMoreBadge && thumbSlides.length > thumbsPerView){
      const badgeSlide = thumbSlides[thumbsPerView - 1];
      const badge = document.createElement("span");
      badge.className = "ws-thumb-more";
      badge.textContent = "+" + (thumbSlides.length - thumbsPerView + 1) + " More";
      badgeSlide.appendChild(badge);
      thumbs.on("sliderMove", function(){ badge.remove(); });
      badgeSlide.addEventListener("click", function(){ badge.remove(); });
    }
  }

  const mainSwiper = new Swiper(mainEl, {
    spaceBetween:10,
    navigation:{
      nextEl:".ws-next",
      prevEl:".ws-prev",
    },
    pagination:{
      el:".wsMainSlider .swiper-pagination",
      clickable:true,
    },
    thumbs: thumbs ? { swiper:thumbs } : undefined,
  });

  mainSwiper.on("slideChange", function(){
    if(mainSwiper.activeIndex >= thumbsPerView - 1){
      const b = document.querySelector(".ws-thumb-more");
      if(b) b.remove();
    }
  });

});

/* =========================
TABS
========================= */

document.addEventListener("DOMContentLoaded", function(){

  const buttons = document.querySelectorAll(".ws-tabs-wrapper .tab-btn");
  const tabs = document.querySelectorAll(".ws-tabs-wrapper .tab-content");

  buttons.forEach(button => {

    button.addEventListener("click", function(){

      const tabId = this.getAttribute("data-tab");
      const target = document.getElementById(tabId);
      if(!target) return;

      buttons.forEach(btn => btn.classList.remove("active"));
      tabs.forEach(tab => tab.classList.remove("active"));

      this.classList.add("active");
      target.classList.add("active");

    });

  });

});

/* =========================
DELIVERY CHECKER
Estimates a delivery window from today using the store's delivery promise
(set in Customize > Premium Product Layout). Sundays are not counted.
Optional per-product overrides: lines "PINCODE|text" in metafield custom.delivery_dates.
========================= */

document.addEventListener("DOMContentLoaded", function(){

  const btn = document.getElementById("ws-check-btn");
  const input = document.getElementById("ws-pincode");
  const result = document.getElementById("ws-delivery-result");
  const cfg = window.wsDeliveryConfig || { minDays:10, maxDays:15 };

  if(!btn || !input || !result) return;

  function escapeHtml(str){
    return String(str).replace(/[&<>"']/g, function(c){
      return { "&":"&amp;", "<":"&lt;", ">":"&gt;", '"':"&quot;", "'":"&#39;" }[c];
    });
  }

  function addBusinessDays(date, days){
    const d = new Date(date);
    let added = 0;
    while(added < days){
      d.setDate(d.getDate() + 1);
      if(d.getDay() !== 0) added++;
    }
    return d;
  }

  function formatDate(d){
    return d.toLocaleDateString("en-IN", { weekday:"short", day:"numeric", month:"short" });
  }

  function findOverride(pin){
    if(!cfg.overrides || typeof cfg.overrides !== "string") return null;
    const rows = cfg.overrides.split(/\r?\n/);
    for(const row of rows){
      const parts = row.split("|");
      if(parts.length === 2 && parts[0].trim() === pin){
        return parts[1].trim();
      }
    }
    return null;
  }

  function check(){

    const pincode = input.value.replace(/\D/g, "").slice(0, 6);
    input.value = pincode;

    if(!/^[1-8][0-9]{5}$/.test(pincode)){
      result.innerHTML = "<div class='delivery-error'>Please enter a valid 6-digit Indian pincode.</div>";
      return;
    }

    try{ localStorage.setItem("wsPincode", pincode); }catch(e){}

    const override = findOverride(pincode);
    let windowText;

    if(override){
      windowText = escapeHtml(override);
    }else{
      const today = new Date();
      const from = addBusinessDays(today, parseInt(cfg.minDays) || 10);
      const to = addBusinessDays(today, parseInt(cfg.maxDays) || 15);
      windowText = "Between <strong>" + formatDate(from) + "</strong> and <strong>" + formatDate(to) + "</strong>";
    }

    let html = "<div class='delivery-success'>" +
      "🚚 <strong>Estimated delivery to " + pincode + ":</strong><br>" + windowText;

    if(cfg.assemblyText){
      html += "<br><br>🛠 " + escapeHtml(cfg.assemblyText);
    }
    if(cfg.notes){
      html += "<br><span class='delivery-note'>" + escapeHtml(cfg.notes) + "</span>";
    }
    html += "</div>";

    result.innerHTML = html;
  }

  btn.addEventListener("click", check);
  input.addEventListener("keydown", function(e){
    if(e.key === "Enter"){ e.preventDefault(); check(); }
  });

  try{
    const saved = localStorage.getItem("wsPincode");
    if(saved){ input.value = saved; }
  }catch(e){}

});

/* =========================
EMI PLANS POPUP
========================= */

document.addEventListener("DOMContentLoaded", function(){

  const modal = document.getElementById("wsEmiModal");
  if(!modal) return;

  let lastFocus = null;

  function openEmi(){
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.body.style.overflow = "hidden";
    const closeBtn = modal.querySelector(".ws-emi-close");
    if(closeBtn) closeBtn.focus();
  }

  function closeEmi(){
    modal.hidden = true;
    document.body.style.overflow = "";
    if(lastFocus) lastFocus.focus();
  }

  document.querySelectorAll("[data-emi-open]").forEach(function(btn){
    btn.addEventListener("click", openEmi);
  });

  modal.querySelectorAll("[data-emi-close]").forEach(function(el){
    el.addEventListener("click", closeEmi);
  });

  document.addEventListener("keydown", function(e){
    if(e.key === "Escape" && !modal.hidden) closeEmi();
  });

});

/* =========================
SAVE EXTRA OFFERS + EMI OPTIONS DRAWER
Banks come from the "EMI bank" blocks; every amount is worked out here from the price.
No Cost EMI: price / months (the bank's interest is given back as an instant discount).
Easy EMI: standard reducing-balance EMI at the bank's yearly rate.
========================= */

(function(){

  var root = document.getElementById("saOffers");
  var drawer = document.getElementById("saEmiDrawer");
  if(!root) return;

  var price = parseFloat(root.getAttribute("data-price")) || 0;
  var logoCount = parseInt(root.getAttribute("data-logos"), 10) || 3;
  var cur = root.getAttribute("data-currency") || "₹";
  var fmt = function(n){ return cur + Math.round(n).toLocaleString("en-IN"); };

  function nums(str){
    return (str || "").split(",").map(function(x){ return parseInt(x, 10); })
      .filter(function(x){ return x > 0; }).sort(function(a, b){ return a - b; });
  }

  function emi(p, ratePa, n){
    var i = ratePa / 1200;
    if(!(i > 0)) return p / n;
    var f = Math.pow(1 + i, n);
    return p * i * f / (f - 1);
  }

  function shortLabel(name, given){
    if(given) return given;
    var words = name.replace(/[^A-Za-z ]/g, " ").split(/\s+/).filter(Boolean);
    if(!words.length) return "";
    if(words[0].length <= 5 && words[0].toLowerCase() !== "bank") return words[0].toUpperCase();
    return words.filter(function(w){ return !/^(of|and|the)$/i.test(w); })
      .map(function(w){ return w[0]; }).join("").toUpperCase().slice(0, 4);
  }

  function markHTML(b, cls){
    if(b.logo) return '<img src="' + b.logo + '" alt="' + b.name.replace(/"/g, "&quot;") + '" loading="lazy">';
    var lab = shortLabel(b.name, b.label);
    return '<span class="sa-bank-mark' + (lab.length > 4 ? " sa-bank-mark--long" : "") + (cls ? " " + cls : "") + '" style="background:' + b.color + '">' + lab + "</span>";
  }

  /* read banks */
  var banks = [];
  root.querySelectorAll("[data-sa-bank]").forEach(function(el){
    var b = {
      name: el.getAttribute("data-name") || "",
      label: el.getAttribute("data-label") || "",
      logo: el.getAttribute("data-logo") || "",
      color: el.getAttribute("data-color") || "#1F3A93",
      nocost: nums(el.getAttribute("data-nocost")),
      standard: nums(el.getAttribute("data-standard")),
      rate: parseFloat(el.getAttribute("data-rate")) || 0,
      min: parseFloat(el.getAttribute("data-min")) || 0
    };
    if(!b.name || price < b.min) return;
    b.nocostPlans = b.nocost.map(function(n){
      return { n: n, monthly: Math.ceil(price / n), interest: 0, total: price };
    });
    b.standardPlans = b.standard.map(function(n){
      var m = Math.ceil(emi(price, b.rate, n));
      return { n: n, monthly: m, interest: Math.max(0, m * n - price), total: m * n };
    });
    b.nocostFrom = b.nocostPlans.length ? Math.min.apply(null, b.nocostPlans.map(function(p){ return p.monthly; })) : 0;
    b.standardFrom = b.standardPlans.length ? Math.min.apply(null, b.standardPlans.map(function(p){ return p.monthly; })) : 0;
    banks.push(b);
  });

  var lists = {
    nocost: banks.filter(function(b){ return b.nocostPlans.length; }),
    standard: banks.filter(function(b){ return b.standardPlans.length; })
  };

  /* cards */
  ["nocost", "standard"].forEach(function(type){
    var card = root.querySelector('[data-sa-card="' + type + '"]');
    if(!card) return;
    var list = lists[type];
    if(!list.length) return;
    var from = Math.min.apply(null, list.map(function(b){ return type === "nocost" ? b.nocostFrom : b.standardFrom; }));
    card.querySelector("[data-sa-amount]").textContent = fmt(from);
    var logos = list.slice(0, logoCount).map(function(b){ return '<span class="sa-of-logo">' + markHTML(b) + "</span>"; }).join("");
    if(list.length > logoCount) logos += '<span class="sa-of-more">+' + (list.length - logoCount) + "</span>";
    card.querySelector("[data-sa-logos]").innerHTML = logos;
    card.hidden = false;
  });

  /* lowest monthly amount overall (used by the mobile bar) */
  var allFrom = [];
  lists.nocost.forEach(function(b){ allFrom.push(b.nocostFrom); });
  lists.standard.forEach(function(b){ allFrom.push(b.standardFrom); });
  var lowest = allFrom.length ? Math.min.apply(null, allFrom) : 0;
  document.querySelectorAll("[data-sa-emi-lowest]").forEach(function(el){
    if(lowest > 0){ el.textContent = fmt(lowest); }
    else { var btn = el.closest("[data-emi-open]"); if(btn) btn.hidden = true; }
  });

  /* drawer lists */
  var arrow = '<svg class="sa-emi-bank__arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  function renderList(type){
    if(!drawer) return;
    var box = drawer.querySelector('[data-sa-list="' + type + '"]');
    if(!box) return;
    box.innerHTML = lists[type].map(function(b, idx){
      var plans = type === "nocost" ? b.nocostPlans : b.standardPlans;
      var from = type === "nocost" ? b.nocostFrom : b.standardFrom;
      var badge = type === "nocost"
        ? '<span class="sa-emi-badge">No Cost EMI</span>'
        : '<span class="sa-emi-badge sa-emi-badge--std">' + (b.rate > 0 ? b.rate + "% p.a." : "Standard EMI") + "</span>";
      var rows = plans.map(function(p){
        return "<tr><td>" + p.n + " months</td><td><b>" + fmt(p.monthly) + "</b></td><td" + (p.interest === 0 ? ' class="sa-zero"' : "") + ">" + fmt(p.interest) + "</td><td>" + fmt(p.total) + "</td></tr>";
      }).join("");
      return '<details class="sa-emi-bank"' + (idx === 0 ? " open" : "") + ">" +
        '<summary><span class="sa-emi-bank__logo">' + markHTML(b) + "</span>" +
        '<span class="sa-emi-bank__info"><span class="sa-emi-bank__name">' + b.name + "</span>" +
        '<span class="sa-emi-bank__from">From ' + fmt(from) + "/Month</span></span>" + badge + arrow + "</summary>" +
        '<table class="sa-emi-plans"><thead><tr><th>EMI Plan</th><th>Monthly</th><th>Interest</th><th>Total</th></tr></thead><tbody>' + rows + "</tbody></table>" +
        "</details>";
    }).join("");
  }
  renderList("nocost");
  renderList("standard");

  /* tabs */
  var tabsWrap = drawer ? drawer.querySelector(".sa-emi-tabs") : null;
  function showTab(type){
    if(!drawer) return;
    if(!lists[type].length) type = type === "nocost" ? "standard" : "nocost";
    drawer.querySelectorAll("[data-sa-list]").forEach(function(l){ l.hidden = l.getAttribute("data-sa-list") !== type; });
    drawer.querySelectorAll("[data-sa-tab]").forEach(function(t){
      var on = t.getAttribute("data-sa-tab") === type;
      t.classList.toggle("is-active", on);
      t.setAttribute("aria-selected", on ? "true" : "false");
    });
  }
  if(tabsWrap && lists.nocost.length && lists.standard.length){
    tabsWrap.hidden = false;
    tabsWrap.querySelectorAll("[data-sa-tab]").forEach(function(t){
      t.addEventListener("click", function(){ showTab(t.getAttribute("data-sa-tab")); });
    });
  }

  /* open / close */
  var lastFocus = null;
  function openDrawer(type){
    if(!drawer || !banks.length) return;
    lastFocus = document.activeElement;
    showTab(type || "nocost");
    if(drawer.parentNode !== document.body) document.body.appendChild(drawer);
    drawer.hidden = false;
    document.body.style.overflow = "hidden";
    requestAnimationFrame(function(){ drawer.classList.add("is-open"); });
    var back = drawer.querySelector(".sa-emi-drawer__back");
    if(back) back.focus();
  }
  function closeDrawer(){
    if(!drawer || drawer.hidden) return;
    drawer.classList.remove("is-open");
    document.body.style.overflow = "";
    setTimeout(function(){ drawer.hidden = true; }, 260);
    if(lastFocus) lastFocus.focus();
  }
  document.querySelectorAll("[data-sa-emi-open]").forEach(function(btn){
    btn.addEventListener("click", function(){ openDrawer(btn.getAttribute("data-sa-emi-open")); });
  });
  document.querySelectorAll("[data-emi-open]").forEach(function(btn){
    btn.addEventListener("click", function(){ openDrawer(lists.nocost.length ? "nocost" : "standard"); });
  });
  if(drawer){
    drawer.querySelectorAll("[data-sa-emi-close]").forEach(function(el){ el.addEventListener("click", closeDrawer); });
  }
  document.addEventListener("keydown", function(e){ if(e.key === "Escape") closeDrawer(); });

  /* sale countdown: "YYYY-MM-DD HH:MM" in India time */
  var timer = root.querySelector("[data-sa-sale-end]");
  if(timer){
    var raw = (timer.getAttribute("data-sa-sale-end") || "").trim();
    var m = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
    if(m){
      var pad = function(x){ return ("0" + x).slice(-2); };
      var end = new Date(m[1] + "-" + pad(m[2]) + "-" + pad(m[3]) + "T" + pad(m[4] || 23) + ":" + (m[5] || "59") + ":59+05:30").getTime();
      var out = timer.querySelector("[data-sa-timer]");
      var tick = function(){
        var s = Math.floor((end - Date.now()) / 1000);
        if(s <= 0){ timer.hidden = true; clearInterval(iv); return; }
        var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), mi = Math.floor(s % 3600 / 60), se = s % 60;
        out.textContent = (d ? d + "d " : "") + h + "h " + mi + "m " + se + "s";
        timer.hidden = false;
      };
      var iv = setInterval(tick, 1000);
      tick();
    }
  }

})();

/* =========================
READ MORE
========================= */

document.addEventListener("DOMContentLoaded", function(){

  const btn = document.querySelector(".ws-read-more-btn");
  const content = document.querySelector(".ws-overview-content");

  if(btn && content){

    btn.addEventListener("click", function(){

      content.classList.toggle("collapsed");
      btn.textContent = content.classList.contains("collapsed") ? "Read More" : "Read Less";

    });

  }

});

/* =========================
SHARE BUTTON
========================= */

document.addEventListener("DOMContentLoaded", function(){

  const shareBtn = document.getElementById("wsShareBtn");

  if(shareBtn){

    shareBtn.addEventListener("click", async function(){

      if(navigator.share){

        try{
          await navigator.share({
            title: document.title,
            text: document.title,
            url: window.location.href
          });
        }catch(err){}

      }else if(navigator.clipboard){

        try{
          await navigator.clipboard.writeText(window.location.href);
          shareBtn.setAttribute("title", "Link copied");
          shareBtn.classList.add("copied");
          setTimeout(function(){ shareBtn.classList.remove("copied"); }, 2000);
        }catch(err){}

      }

    });

  }

});

/* =========================
PRODUCT WISHLIST
========================= */

function wsReadWishlist(){
  try{
    return JSON.parse(localStorage.getItem('wsWishlist')) || [];
  }catch(e){
    return [];
  }
}

window.addEventListener('pageshow', function() {
  const wishlist = wsReadWishlist();
  document.querySelectorAll('.ws-wishlist-btn').forEach(btn => {
    btn.classList.toggle('active', wishlist.includes(btn.dataset.productHandle));
  });
});

document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('.ws-wishlist-btn').forEach(function(button) {

    const handle = button.dataset.productHandle;

    if (wsReadWishlist().includes(handle)) {
      button.classList.add('active');
    }

    button.addEventListener('click', function(e) {

      e.preventDefault();

      let wishlist = wsReadWishlist();

      if (wishlist.includes(handle)) {
        wishlist = wishlist.filter(item => item !== handle);
        button.classList.remove('active');
      } else {
        wishlist.push(handle);
        button.classList.add('active');
      }

      wishlist = [...new Set(wishlist)];

      try{
        localStorage.setItem('wsWishlist', JSON.stringify(wishlist));
      }catch(e){}

      if (typeof window.updateWishlistCount === 'function') {
        window.updateWishlistCount();
      }

    });

  });

});

/* =========================
QUANTITY
========================= */

document.addEventListener("DOMContentLoaded", function(){

  const qtyInput = document.getElementById("wsQuantity");
  const plusBtn = document.querySelector(".ws-qty-btn.plus");
  const minusBtn = document.querySelector(".ws-qty-btn.minus");
  const targets = [
    document.getElementById("wsCartQty"),
    document.getElementById("wsBuyQty")
  ].concat(Array.from(document.querySelectorAll(".wsStickyQty")));

  if(!qtyInput) return;

  function updateQty(value){
    value = Math.max(1, parseInt(value) || 1);
    qtyInput.value = value;
    targets.forEach(function(el){ if(el){ el.value = value; } });
  }

  if(plusBtn){
    plusBtn.addEventListener("click", function(){
      updateQty((parseInt(qtyInput.value) || 1) + 1);
    });
  }

  if(minusBtn){
    minusBtn.addEventListener("click", function(){
      updateQty((parseInt(qtyInput.value) || 1) - 1);
    });
  }

  qtyInput.addEventListener("change", function(){
    updateQty(qtyInput.value);
  });

});
